import { useEffect, useState } from 'react';
import { NumberInput } from '@library/components/inputs';
import { PrimaryButton } from '@library/components/buttons';

export interface BoardBuilderRankProjectionsProps {
  disabled: boolean;
  resetRankValue: boolean;
  onRanking: (value: number) => void;
}

export const BoardBuilderRankProjections = ({
  disabled,
  resetRankValue,
  onRanking
}: BoardBuilderRankProjectionsProps) => {
  const [rank, setRank] = useState<string>('');

  useEffect(() => {
    if (resetRankValue) {
      setRank('');
    }
  }, [resetRankValue]);

  const handleRankClick = (value: string | undefined) => {
    if (!!value && !Number.isNaN(value)) {
      onRanking(Number(value));
    }
  };

  return (
    <div className="ml-auto flex items-center gap-2 p-4">
      <NumberInput
        className="font-heebo bg-soFresh-120 text-soClean-100 h-8 w-16 shrink-0 basis-16 justify-center rounded-md p-2 text-sm font-medium leading-normal tracking-tight"
        disabled={disabled}
        id="board-builder-rank-projections"
        value={rank}
        onValueChange={setRank}
      />
      <PrimaryButton
        className="flex h-10 items-center justify-center p-4"
        disabled={disabled || !rank}
        handleOnClick={() => handleRankClick(rank)}
        title="Rank"
      >
        Rank
      </PrimaryButton>
    </div>
  );
};
